/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordsResponseData } from "./RecordsResponseData";
export const RecordsResponse = core.serialization.object({
    data: RecordsResponseData,
});
